import React from "react"

export default function InlineForm(props){
	return <form className={"inline-form"}>
		{props.children}
	</form>
}